export default __webpack_public_path__ + "f697e178e31dd29c185b726aea83950c.svg";